import { motion } from "framer-motion";
import { FaPaw, FaStethoscope, FaHome } from "react-icons/fa";
import Navbar from "./Navbar.js";
import bunny from "../images/servicespet.avif";
import Footer from "./Footer.js";
const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const services = [
  {
    title: "Pet Training",
    description:
      "We offer training classes to improve your pet’s behavior, socialization, and obedience. Strengthen your bond with your furry friend and enjoy a harmonious relationship built on trust and communication.",
    image: "https://example.com/pet-training.jpg",
    icon: <FaPaw className="absolute text-gray-200 text-8xl" />,
  },
  {
    title: "Veterinary Care",
    description:
      "Our experienced vets provide top-notch medical care, from routine check-ups to complex procedures, ensuring your furry friend enjoys a long, healthy life. We’re your trusted partner in pet wellness.",
    image: "https://example.com/veterinary-care.jpg",
    icon: <FaStethoscope className="absolute text-gray-200 text-8xl" />,
  },
  {
    title: "Pet Boarding",
    description:
      "Leave your pet with us while you’re away, knowing they’ll receive love, attention, and a comfortable environment akin to a home away from home. Your pet’s happiness is our priority.",
    image: "https://example.com/pet-boarding.jpg",
    icon: <FaHome className="absolute text-gray-200 text-8xl" />,
  },
];

const fadeIn = {
  hidden: { opacity: 0, y: 50 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay },
  }),
};

const Services = () => {
  return (
    <div className="bg-gray-50 ">
      <Navbar />
      <div className="bg-[#d4b8a3] font-serif mt-28 flex flex-col md:flex-row items-center">
        <motion.div
          className="md:w-1/2 flex justify-center mt-8 md:mt-0 px-8"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          <img
            src={bunny}
            alt="Bunny"
            className="rounded-xl max-w-sm md:max-w-md"
          />
          <div className="relative left-26 top-20 transform -translate-x-1/2">
            <div className="text-6xl text-brown-500 animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>
          <div className="absolute left-36 top-36 transform translate-x-1/2">
            <div className="text-6xl text-brown-500 animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="md:w-1/2 text-left px-8"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <motion.h1
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className="text-8xl font-bold  text-white font-serif"
          >
            Our Pet Care <br />
            Solutions
          </motion.h1>
        </motion.div>
      </div>
      <motion.div
        className="bg-[#F5EDE6] font-serif py-20 px-6"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="flex flex-col space-y-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="relative bg-[#d4b8a3]  rounded-full p-6 flex flex-col items-center text-center overflow-hidden transition-transform duration-300 ease-in-out hover:scale-105 group"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={index * 0.2}
              variants={fadeIn}
            >
              <div className="absolute top-12 left-1/2 transform -translate-x-1/2 text-gray-100 group-hover:text-white border-4 border-white rounded-full p-4 transition-all duration-300">
                {service.icon}
              </div>
              <div className="relative z-10">
                <motion.img
                  src={service.image}
                  alt={service.title}
                  className="w-16 h-16 rounded-full object-cover mb-4"
                  whileHover={{ scale: 1.2 }}
                  transition={{ duration: 0.3 }}
                />
                <h3 className="text-3xl font-semibold text-gray-800 group-hover:text-white transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-xl text-gray-600 mt-2 group-hover:text-white transition-colors duration-300">
                  {service.description}
                </p>
              </div>
              <div className="absolute inset-0 bg-brown-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0"></div>
            </motion.div>
          ))}
        </div>
      </motion.div>
      <motion.div
        className="flex flex-col bg-gray-100 text-center font-serif lg:flex-row items-center justify-center lg:justify-center py-36 px-8 lg:px-16 relative" // Add 'relative' here for positioning context
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.div
          className="text-center lg:text-center flex flex-col items-center justify-center"
          variants={fadeIn}
          custom={0.1}
        >
          <h1 className="text-6xl font-bold text-gray-800 mb-4">
            Ready to Give Your Pet the Best Care?
          </h1>

          <p className="text-xl text-gray-600 mb-6">
            Explore Our Services and Treat Your Furry Companion to a World of
            Love, Health, and Happiness.
          </p>
          <motion.button
            className="bg-brown-500 text-white text-xl px-6 py-3 rounded-full shadow-md hover:bg-brown-600 transition duration-300"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Join Today!
          </motion.button>
        </motion.div>
        <div className="absolute top-12 left-20 transform -translate-x-1/2 translate-y-1/2 text-6xl text-brown-500 animate-paw-left-right">
          <i className="fa fa-paw"></i>
        </div>
        <div className="absolute bottom-28 right-36 transform translate-x-1/2 -translate-y-1/2 text-8xl text-brown-500 animate-paw-left-right">
          <i className="fa fa-paw"></i>
        </div>
      </motion.div>

      <Footer />
    </div>
  );
};

export default Services;
